import HowToResultsTablet from './HowToResultsTablet'

export default HowToResultsTablet
